<div
  class="container"
  [class.containerHasBreadcrumbs]="containerHasBreadcrumbs"
  [class.containerHasTabs]="containerHasTabs"
  [class.containerHasPadding]="containerHasPadding">
  <biosimulations-spinner [label]="'Loading '" [messages]="messages" [intervalDuration]="intervalDuration">
  </biosimulations-spinner>
</div>
